import BaseModel from './BaseModel';
import moment from 'moment';

import cinech from '../assets/images/integrations/cinech.webp';
import eventival from '../assets/images/integrations/eventival.webp';
import json from '../assets/images/integrations/json.webp';
import kronos from '../assets/images/integrations/kronos.webp';
import raw from '../assets/images/integrations/file.webp';

/** Class representing a tag. */
class Log extends BaseModel {
    static BOOKING_CONFIRM_TYPE        = 'confirm_booking';
    static UNBOOK_TYPE                 = 'unbook';
    static TICKET_CREATE_TYPE          = 'ticket_create';
    static TICKET_ACTIVATE_TYPE        = 'activate';
    static TICKET_DELETE_TYPE          = 'delete';
    static TICKET_BLOCK_TYPE           = 'block';
    static TICKET_UNBLOCK_TYPE         = 'unblock';
    static TICKET_CHECKIN_TYPE         = 'checkin';
    static TICKET_CHECKOUT_TYPE        = 'checkout';
    static TICKET_VOTE_TYPE            = 'vote';
    static TICKET_FAILED_CHECKIN_TYPE  = 'failed_checkin';
    static TICKET_FAILED_CHECKOUT_TYPE = 'failed_checkout';
    static TICKET_CHANGE_TYPE_TYPE     = 'change_type';
    static TICKET_WINDOW_NBOOKINGS_TYPE = 'ticket_window_nbookings';
    static TICKET_ARTICLE_QUANTITY_TYPE = 'ticket_article_quantity';
    static TICKET_WALLET_CREDIT_TYPE   = 'ticket_wallet_credit';
    static TICKET_WALLET_DEBIT_TYPE    = 'ticket_wallet_debit';
    static EMAIL_SENT_TYPE             = 'email_sent';
    static EMAIL_ERROR_TYPE            = 'email_error';
    static EMAIL_OPENED_TYPE           = 'email_opened';
    static ORDER_CONFIRMATION          = 'order_confirmation';
    static REFUND_CONFIRMATION         = 'refund_confirmation';
    static SCREENINGS_IMPORT           = 'screenings_import';
    static TICKETS_IMPORT              = 'tickets_import';
    static PLACES_IMPORT               = 'places_import';
    static HEALTH_CHECK_RUN            = 'health_checks_run';
    static SCREENING_CREATE            = 'screening_create';
    static SCREENING_UPDATE            = 'screening_update';
    static SETTINGS_UPDATE             = 'settings_update';
    static PRICING_CREATE              = 'pricing_create';
    static PRICING_UPDATE              = 'pricing_update';
    static TICKETTYPE_CREATE           = 'tickettype_create';
    static TICKETTYPE_UPDATE           = 'tickettype_update';
    static RETENTION_RUN_TYPE          = 'retention_run';

    constructor(properties) {
        super(properties || {});

        if (this.created_at)
            this.created_at = moment(this.created_at);

        ['inserted', 'updated', 'activated', 'invalid'].forEach(property => {
            if (this[property])
                this[property] = (this[property] || []).map(entry => {
                    if ('start_at' in entry)
                        entry.start_at = moment(entry.start_at);
                    if ('stop_at' in entry)
                        entry.stop_at = moment(entry.stop_at);

                    return entry;
                });
        });
    }

    sourceIcone() {
        switch (this.source) {
            case 'cinech':
                return cinech;
            case 'eventival':
                return eventival;
            case 'json':
                return json;
            case 'kronos':
                return kronos;
            case 'raw':
                return raw;
            default:
                return null;
        }
    }

    sourceName(t) {
        if (!this.source)
            return null;

        return t(`logs.source.${this.source}`);
    }
}

export default Log;
